// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

export const resources = {
  en: {
    translation: {
      language: 'Language',
      languageMessage: 'You can view the participant form in various available languages.',
      propertyAddress: 'Property Address',
      orderDetails: 'Order Details',
      fileNumber: 'File Number',
      title: 'Title / Escrow Company',
      contact: 'Contact Information',
      note: 'Note : Your progress in previous sections is automatically saved. However, the details of the current section will not be saved automatically unless you click on the NEXT STEP button at the end of the section.',
      note1:
        'Note : The details of the current section will not be saved automatically unless you click on the NEXT STEP button at the end of the section.',
      notePOA:
        'Note: A power of attorney, also known as an “attorney-in-fact” is used in many real estate transactions to allow someone else to be able to complete closings or giving someone else the power to sell your properties.',
      noteTrustLlcNoAdditionalParticipant:
        'Note: Because the primary participant is registered as a Trust or LLC entity, additional participants cannot be added here. Please use the Add Another Trustee/Member option in the entity section to include other individuals associated with this entity.',
      noteAdditionalService:
        'Note : You can add an additional service and its relevant details if it is not listed here.',
      addParticipant: 'Add Participant',
      addParticipantConfirmation:
        ' <b>Would you like to add an additional participant to this transaction?</b> You will be prompted to provide basic information <b>(Name, Email, Phone Number)</b> for any additional participants.',
      removeParticipant: 'Remove Participant',
      removeParticipantConfirmation:
        ' <b>Are you sure you want to remove this participant from the transaction?</b> This action cannot be undone and all data entered for this participant will be permanently deleted.',
      serviceLabel: 'Service Label',
      serviceLabelRequired: 'Service Label is required',
      addHOA: 'Add HOA',
      addLoan: 'Add Loan',
      addBuyer: 'Add Another Buyer',
      addBorrower: 'Add Another Borrower',
      addSeller: 'Add Another Seller',
      ok: 'OK',
      spouseAlreadyFlaggedTitle: 'Spouse Already Identified',
      spouseAlreadyFlaggedBody:
        "You already provided your spouse's information and indicated that your spouse is a Seller on this transaction. This additional Seller cannot also be marked as your spouse.",
      removeSeller: 'Remove This Seller',
      removeHOA: 'Remove This HOA',
      removeLoan: 'Remove This Loan',
      removeBuyer: 'Remove This Buyer',
      removeBorrower: 'Remove This Borrower',
      addCard: 'Add Credit Card',
      addLien: 'Add Lien Details',
      addUtility: 'Add Utility Service',
      removeLien: 'Remove This Lien',
      removeUtility: 'Remove This Utility',
      noteRemoveLien:
        '<b>Are you sure you want to remove this lien from the transaction?</b> This action cannot be undone and all data entered for this lien will be permanently deleted.',
      noteRemoveUtility:
        '<b>Are you sure you want to remove this utility service from the transaction?</b> This action cannot be undone and all data entered for this utility service will be permanently deleted.',
      noteHOA:
        '<b>Would you like to add an additional HOA for this transaction?</b> You will be prompted to provide basic information <b>(Association Name, Management Company, Association Dues)</b> for any additional HOA.',
      noteLoan:
        '<b>Would you like to add an additional Loan for this transaction?</b> You will be prompted to provide basic information <b>(Lender Name, Loan Number, Approximate Balance)</b> for any additional Loans.',
      noteBuyer:
        '<b>Would you like to add an additional buyer for this transaction?</b> You will be prompted to provide basic information <b>(Buyer Name, Email, Phone, DOB, etc.)</b> for any additional buyer.',
      noteBorrower:
        '<b>Would you like to add an additional borrower for this transaction?</b> You will be prompted to provide basic information <b>(Name, Email, Phone Number)</b> for any additional borrower.',
      noteRemoveHOA:
        '<b>Are you sure you want to remove this HOA from the transaction?</b> This action cannot be undone and all data entered for this HOA will be permanently deleted.',
      noteRemoveLoan:
        '<b>Are you sure you want to remove this loan from the transaction?</b> This action cannot be undone and all data entered for this loan will be permanently deleted.',
      noteRemoveBuyer:
        '<b>Are you sure you want to remove this buyer from the transaction?</b> This action cannot be undone and all data entered for this buyer will be permanently deleted.',
      noteRemoveBorrower:
        '<b>Are you sure you want to remove this borrower from the transaction?</b> This action cannot be undone and all data entered for this borrower will be permanently deleted.',
      lastSection: 'Signature & Documents',
      participantSignature: 'Participant Signature',
      signRequired: 'Please add signature to proceed further.',
      additionalSignature: "Additional Participant's Signature",
      lastStepMessage1: 'These document(s) will be automatically signed electronically at the end.',
      lastStepMessage2: `The form will NOT be submitted until ALL documents are reviewed, signature is
                  added and the submit button is clicked.`,
      submit: 'Submit',
      congratulations: 'Congratulations!',
      download: 'Click Here To Download Final Document Package',
      submissionMessage1: 'Completed. Your documents have been successfully completed.',
      submissionMessage2:
        'You will receive a confirmation email shortly. Your documents are now under review, and your closer will contact you if any additional information is needed.',
      submissionMessage3: ' Secured and authenticated by ClientVerify California Inc ™',
      submissionMessage4: `You can safely close this page using your browser's close button. If you want to revisit the form to review documents, you can follow the link in the invite or in the confirmation email.`,
      entityMemberIdIntroTitle: 'Complete your member details',
      entityMemberIdIntroBody:
        '<ul class="entity-member-intro-list"><li>Your <strong>Trust/LLC</strong> has invited you to complete your member details. You may be asked to upload a <strong>government-issued photo ID</strong> and/or enter your <strong>Social Security number (SSN)</strong>, depending on what is shown in the form. You can also review the information your primary <strong>trustee/member</strong> has already entered on behalf of your <strong>Trust/LLC</strong>.</li><li>Please check the <strong>highlighted portion</strong> in the active section. You will be automatically scrolled to those details.</li><li>Once you complete the required fields shown, a <strong>confirmation of saving your data</strong> will appear. After that, you can safely close this page.</li></ul>',
      entityMemberIdIntroConfirm: 'Got it',
      entityMemberFocusZoneTitle: 'Your details to complete',
      entityMemberFocusZoneSubtitle:
        'Please complete the highlighted fields below, including a government-issued ID upload and/or Social Security number if shown.',
      memberReturnToIdUploadLabel: 'Return to Government ID Upload & SSN',
      memberReturnToIdUploadHint: 'Complete your required member details',
      memberPrivateCompleteTitle: "You're all set!",
      memberPrivateCompleteBody:
        'We have received your required details. You can safely close this page now using your browser’s close button.',
      memberPrivateCompleteConfirm: 'OK',
      idOnlyVerificationCompleteTitle: "You're all set!",
      idOnlyVerificationCompleteBody:
        'Your identity verification has been submitted successfully. You can safely close this page now using your browser’s close button.',
      idOnlyVerificationCompleteConfirm: 'OK',
      idOnlyVerificationOfficerCompleteTitle: "You're all set!",
      idOnlyVerificationOfficerCompleteBody:
        'The participant’s identity verification has been submitted successfully. You can safely close this page now using your browser’s close button.',
      idOnlyVerificationOfficerCompleteConfirm: 'OK',
      idOnlyVerificationGreeting: 'Hello, {{name}}',
      idOnlyVerificationOfficerGreeting: 'Hello, {{name}}',
      idOnlyVerificationParticipantLabel: 'Participant',
      idOnlyVerificationParticipantToVerify: 'Participant(s) to verify : {{names}}',
      idOnlyVerificationGuideText:
        'Please verify your identity for this transaction. Follow the steps below to complete your ID verification securely.',
      idOnlyVerificationOfficerGuideText:
        'You are verifying this participant’s identity in person. Follow the steps below to capture their government-issued ID and complete verification securely.',
      idOnlyVerificationStep_uploadButton:
        'Click the Capture Government Issued ID button below to begin.',
      idOnlyVerificationStep_enterSSN: 'Enter Social Security Number.',
      idOnlyVerificationStep_mobileOrQr:
        'Scan QR Code or enter mobile phone to open ID verification session.',
      idOnlyVerificationStep_uploadIdSelfie:
        'Follow the prompts in the session before returning here to complete.',
      idOnlyVerificationOfficerStep_uploadButton:
        'Click the Capture Government Issued ID button below to begin verifying the participant.',
      idOnlyVerificationOfficerStep_enterSSN: 'Enter Social Security Number of participant.',
      idOnlyVerificationOfficerStep_mobileOrQr:
        'Scan QR Code or enter mobile phone to open ID verification session. ',
      idOnlyVerificationOfficerStep_uploadIdSelfie:
        'Follow the prompts in the session before returning here to complete.',
      idOnlyProgressTitle: 'ID Verification Progress',
      idOnlyProgressOfficerTitle: 'Participant ID Verification',
      idOnlyProgressStarted: 'Started',
      idOnlyProgressOfficerStarted: 'Started',
      idOnlyProgressUpload: 'Capture Government ID',
      idOnlyProgressOfficerUpload: 'Capture Participant ID',
      idOnlyProgressVerified: 'Verified',
      idOnlyProgressNotVerified: 'Not Verified',
      idOnlyProgressComplete: 'Complete',
      idOnlyProgressOfficerComplete: 'Complete',
      idOnlyProgressCompleteHint: '(click complete verification)',
      idOnlyVerificationTrustIntro:
        '{{company}} has requested identity verification as part of this process. Continue if you recognize this request and trust the organization requesting your ID.',
      idOnlyVerificationTrustIntroNoCompany:
        'You have been requested to complete identity verification as part of this process. Continue only if you recognize this request and trust the organization requesting your ID.',
      idOnlyVerificationOfficerTrustIntro:
        '{{company}} has requested identity verification for {{participantName}}. Continue only if you are the authorized officer completing this verification in person.',
      idOnlyVerificationOfficerTrustIntroNoCompany:
        'You have been asked to verify {{participantName}}’s identity in person. Continue only if you recognize this request and are authorized to complete this verification.',
      idOnlyVerificationTrustContactHeading: 'Any Questions?',
      idOnlySubmitPendingTitle: 'Verification incomplete',
      idOnlySubmitPendingBody:
        'Please complete necessary details for all participants before submitting.',
      idOnlySubmitConfirmTitle: 'Submit verification',
      idOnlySubmitConfirmBody:
        'Are you sure you want to submit? <b>You will not be able to make any changes after submitting.</b>',

      somethingWrong: 'Something went wrong!',
      creditCardLabel: 'Credit Card Information',
      creditCardMessage:
        'By providing your card information, you allow localhost:3000 to charge your card for   future payments in accordance with their terms.',
      creditCardSuccess: 'Credit card has been added successfully.',
      pendingReview: 'Pending Review',
      docReviewed: 'You have reviewed this document.',
      additionalDocs: 'Additional Documents',
      signRequired2: 'Please add signature first to proceed further for documents.',
      qrNote: `Please click the provided link below
                and follow the instructions to capture images to verify your government issued ID.
                You will only be allowed to proceed further upon successful verification.`,
      qrNoteReopen: `You’ll need to complete the Government ID verification process again as the form has been reopened. Please click the provided link below
                and follow the instructions to capture images to verify your government issued ID.
                You will only be allowed to proceed further upon successful verification.`,
      fnameError: `The First Name or Last Name does not appear to be the same as the name on your uploaded
              Government-issued ID`,
      mailingAddressError: `Your mailing address does not match the address on your uploaded government issued ID.
              Click on the "Fetch Address" button to fetch the address from the government issued ID
              into the Mailing Address fields.`,
      mobyError: `We're having trouble verifying your Government ID electronically. We'll proceed with manual verification using your last uploaded images. If you'd like to upload new images, please click the 'Upload for Manual Verification' button, or click 'Use Last Images' to continue with the existing ones.`,
      signDoc:
        'Please review all documents carefully before signing. Once reviewed, sign and save a copy for your records.',
      signPlaceholder: 'Sign here and click save when completed.',
      signPlaceholderDocsNotReviewed:
        'Please review documents above then only you will be able to sign.',
      sigDocsNotReviewedReviewLink: 'Review',
      sigDocsNotReviewedCanvasSuffix: ' all above listed documents before signing in this box.',
      mobyUpload: 'Upload Document',
      uploadDocument: 'Capture Government Issued ID',
      reuploadGovId: 'Re-upload Government Issued ID',
      reuploadGovIdConfirmTitle: 'Re-upload Government Issued ID?',
      reuploadGovIdConfirmDescription:
        'You will need to re-upload your government-issued ID images. This will clear the previously uploaded ID details. Do you want to continue?',
      reuploadGovIdSuccess:
        'You can upload new ID images using the button shown on screen. Previous ID details were cleared from the form.',
      reuploadGovIdLimitReached:
        'You have reached the maximum number of re-upload attempts. Please contact your agent for more information.',
      reuploadGovIdAttemptsRemaining:
        'You can re-upload your ID up to {{count}} more times if needed.',
      govIdHeader: 'Uploaded Government Issued ID',
      verified: 'Verified',
      pending: 'Pending',
      nameErrorMsg: `The value in this field does not appear to be the same as the name on your uploaded
              Government-issued ID. Do you want to update this field to match?`,
      yes: 'Yes',
      no: 'No',
      fetchAdr: 'Fetch Address',
      uploadIdModalHeader: 'Upload Government Issued ID',
      dReview: 'Document Review',
      dReviewMessage1:
        'Form cannot be submitted until all documents are reviewed and the signature is applied.',
      dReviewMessage2: `Please review your information carefully. Once you select continue, the form will be finalized and submitted, and you will not be able to make changes.`,
      prevStep: 'Previous Step',
      nextStep: 'Next Step',
      stay: 'Stay',
      next: 'Next',
      validation: 'Missing Information',
      close: 'Close',
      upload: 'Upload',
      signatureNote:
        '*Note: This is a graphical signature captured using the computer’s input devices and does not constitute a digital or electronic signature. By signing in the box below, you authorize us to apply this signature to each document included in this signing package upon completion.',
      invitationError: `We're generating a QR code or invitation link for your government ID verification. Please wait a moment. If you still don't see the QR code or invitation link, please reload the page`,
      regenerate: 'Regenerate',
      uploadNewImages: 'Upload for Manual Verification',
      useLastImages: 'Use Last Images',
      dlError: `A copy of your government issued ID has not been uploaded. Please click the links below to navigate.`,
      validationErrorLastStep: `There are some unanswered required fields that will need to be completed before you submit your documentation. Please click the links below to navigate.`,
      combinedErrorLastStep: `A copy of your government-issued ID has not been uploaded, and there are some unanswered required fields that will need to be completed before you submit your documentation. Please click the links below to navigate.`,
      goToSection: 'Go Back to Incomplete Section',
      stepValidationMessage: `There are some unanswered required fields in this section. These will need to be completed before you submit your documentation. Would you like to leave anyway?`,
      stepDlValidationMessage: `You haven't uploaded your government-issued ID yet. Would you like to leave anyway?`,
      bothValidationFailedMessage: `There are some unanswered required fields in this section and the government issued ID upload is pending. These will need to be completed before you submit your documentation. Would you like to leave anyway?`,
      welcomePageValidationMessage: `Attention: Before proceeding to the next section, please scroll to the bottom of this page to review and acknowledge the statements provided.`,
      addAdditionalDocs: 'Click to Review All Documents',
      makeSpouseAdditionalBuyer: 'Make Spouse Additional Buyer',
      makeSpouseAdditionalBuyerDescription:
        'Are you sure you want to add spouse as an additional buyer? Please check the end of the form to confirm that the spouse has not already been added as an additional buyer by the closer.',
      commentSection:
        'If you have any questions about this section, need clarification, or want to highlight something important to your closer, please add your comment below.',
      commentPlaceholder: 'Add your comment here...',
      sectionGuideMessage:
        " Please answer the questions to the best of your knowledge. If you're unsure about any item, use the comment box at the bottom of this section to provide additional details.",
      gotIt: 'Got it',
      tip: 'Need Help?',
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'en', // default language
  fallbackLng: 'en', // fallback language
  interpolation: {
    escapeValue: false, // react already safes from xss
  },
});

export const addTranslations = (lng, translations) => {
  if (!i18n.hasResourceBundle(lng, 'translation')) {
    i18n.addResourceBundle(lng, 'translation', translations);
  } else {
    i18n.addResources(lng, 'translation', translations);
  }
  i18n.changeLanguage(lng); // Switch to the selected language
};

export default i18n;
